import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import connect from 'components/lib/connect';
import Conversation from './conversation';
import ExpandableProfileCard from 'components/customer/profile/expandable_profile_card';
import { sortConversations } from 'models/customer';

export function ConversationList({ conversations, customerId, isLoading }) {
  if (!isLoading && !conversations.length) {
    return null;
  }
  return (
    <ExpandableProfileCard data-aid="conversationListCard" title="Conversations" isLoading={isLoading}>
      {conversations.map(conversation => (
        <Conversation conversation={conversation} customerId={customerId} key={conversation.id} />
      ))}
    </ExpandableProfileCard>
  );
}

ConversationList.propTypes = {
  conversations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(ConversationList);

function mapStateToProps({ getProvider }, { customerId }) {
  let conversations = getProvider('conversations');
  let topics = getProvider('topics');
  let profile = getProvider('profile');
  return {
    conversations: sortConversations(conversations.findAll()).reverse(),
    customerId: _(profile.get()).get('id'),
    isLoading: conversations.isLoading() || topics.isLoading(),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/conversation_list.jsx